// extracted by mini-css-extract-plugin
module.exports = {"calender-desktop":"CalendarDesktop_calender-desktop__8_d5I"};